import Vuex from 'vuex'
import Vue from 'vue'

import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import state from "./state";

import technischeUntersuchungenModule from "./technische-untersuchungen";
import anfallsanamneseModule from "./anfallsanamnese";
import diagnosestellungModule from "./diagnosestellung";
import therapieModule from "./therapie";

Vue.use(Vuex)


const cdssStoreConfig = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,

    modules: {
        technischeUntersuchungen: technischeUntersuchungenModule,
        anfallsanamnese: anfallsanamneseModule,
        diagnosestellung: diagnosestellungModule,
        therapie: therapieModule
    }
}

export default cdssStoreConfig
